module.exports = __webpack_public_path__ + "static/fonts/ibm-plex-mono-v12-latin-500.f918a0c.woff2";